export function fixedHeader() {
  const target = document.getElementById('js-fixedHeader');
  if (!target) return;
  const trigger = document.getElementById('js-header');

  const hideNav = (nav) => {
    nav.classList.remove('_fixed');
  };
  const showNav = (nav) => {
    nav.classList.add('_fixed');
  };
  const observerFunction = (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        showNav(target);
      } else {
        hideNav(target);
      }
    });
  };

  const observerOption = new IntersectionObserver(observerFunction, {
    root: null,
    rootMargin: '0px 0px 0px 0px',
    threshold: 0,
  });

  const executeObserver = (observer) => {
    observer.observe(trigger);
  };

  executeObserver(observerOption);
}
